import type { SecretsModeBlock } from "@/lib/dashboardApi";
import { OperatorPanel } from "@/components/admin/dashboard/OperatorPanel";

export function SecretsModeCard({
  data,
}: {
  data: SecretsModeBlock;
}): JSX.Element {
  return (
    <OperatorPanel
      testId="platform-health-secrets-mode"
      kicker="Secrets"
      title="Secrets mode"
    >
      <dl className="grid grid-cols-2 gap-2 text-sm">
        <dt className="text-text-secondary">JWT</dt>
        <dd
          data-testid="secrets-mode-jwt"
          className="font-medium capitalize text-text-primary"
        >
          {data.jwt}
        </dd>
        <dt className="text-text-secondary">Integration encryption</dt>
        <dd
          data-testid="secrets-mode-integration"
          className="font-medium capitalize text-text-primary"
        >
          {data.integration_encryption}
        </dd>
      </dl>
    </OperatorPanel>
  );
}
